<template>
  <p id="form-viewer-header-d76k2r" v-if="formHeader" v-html-sanitize="formHeader" />
</template>

<script>
export default {
  name: "FormViewerHeader",
  props: ["formHeader"]
};
</script>
